import { render, staticRenderFns } from "./RiderOverview.vue?vue&type=template&id=2f58767f&"
import script from "./RiderOverview.vue?vue&type=script&lang=js&"
export * from "./RiderOverview.vue?vue&type=script&lang=js&"
import style0 from "./RiderOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports